import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=09f13699"
import script from "./Skill.vue?vue&type=script&lang=ts"
export * from "./Skill.vue?vue&type=script&lang=ts"
import style0 from "./Skill.vue?vue&type=style&index=0&id=09f13699&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports